import { useEffect } from "react";
import { useStore } from "../store/useStore";

/**
 * Der Demo-Hinweis — EIN Ort statt bisher zwei.
 *
 * Er stand zuerst in der Kopfzeile und schob dort auf dem Telefon die
 * Bedienelemente rechts aus dem Bild; danach schwebte er auf der Karte, war
 * aber nur dort zu sehen. Jetzt klebt er unter der Kopfzeile und gilt fuer
 * jede Seite: `fixed` statt `sticky`, weil beide Geruest-Fassungen ihren
 * Inhalt ohnehin in einen festen Rahmen unterhalb von --kopf-h setzen — ein
 * `sticky` haette darin keinen Bezug zum Scrollen.
 *
 * Reine Anzeige: `pointerEvents: none`, damit ein Klick daneben die Karte
 * trifft und kein unsichtbares Feld im Weg liegt.
 *
 * Warum ein eigenes BAND und nicht bloss ein schwebender Chip: mittig unter
 * der Kopfzeile lag er auf dem Suchfeld der Karte, und links wie rechts stehen
 * dort die Panel-Knoepfe — unter der Kopfzeile ist auf der Karte schlicht kein
 * freier Fleck. Statt ihn irgendwohin auszuweichen, schiebt er den Inhalt um
 * seine eigene Hoehe nach unten (--demo-band, gelesen von beiden Geruesten).
 * Damit ueberlappt er nichts, egal was die Seite darunter zeigt.
 */
/** Hoehe des Bandes. Steht hier und NICHT im CSS, weil die Geruest-Rahmen
 *  denselben Wert brauchen — eine Zahl an zwei Orten laeuft auseinander. */
const BAND = 26;

export function DemoChip() {
  const demo = useStore((s) => !!s.auth?.demo);
  // Die Wurzelvariable traegt die Hoehe an die festen Rahmen der Geruest-
  // Fassungen weiter. Beim Verlassen der Demo muss sie WEG, sonst bliebe unter
  // der Kopfzeile ein leerer Streifen stehen.
  useEffect(() => {
    const w = document.documentElement;
    w.style.setProperty("--demo-band", demo ? `${BAND}px` : "0px");
    return () => {
      w.style.removeProperty("--demo-band");
    };
  }, [demo]);
  if (!demo) return null;
  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        top: "var(--kopf-h)",
        left: 0,
        right: 0,
        height: "var(--demo-band)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 40,
        pointerEvents: "none",
        fontSize: 11.5,
        fontWeight: 700,
        letterSpacing: ".04em",
        color: "#8a6d1f",
        background: "rgba(217,164,65,.16)",
        borderBottom: "1px solid rgba(217,164,65,.4)",
        backdropFilter: "blur(6px)",
      }}
      title="Demo — Änderungen bleiben in diesem Browser und verschwinden beim Neuladen"
    >
      DEMO — Änderungen bleiben nur in diesem Browser
    </div>
  );
}
